var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJusticeScaleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3743 29.6688L10.3314 14.7308L4.28857 29.6688M16.3743 29.6688C16.3743 31.2714 15.7376 32.8084 14.6044 33.9416C13.4711 35.075 11.9341 35.7117 10.3314 35.7117C8.72877 35.7117 7.19173 35.075 6.05848 33.9416C4.92523 32.8084 4.28857 31.2714 4.28857 29.6688M16.3743 29.6688H4.28857",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7114 19.9998L29.6686 5.93207L23.6257 19.9998M35.7114 19.9998C35.7114 21.6025 35.0748 23.1395 33.9416 24.2728C32.8082 25.406 31.2712 26.0427 29.6686 26.0427C28.066 26.0427 26.5289 25.406 25.3956 24.2728C24.2624 23.1395 23.6257 21.6025 23.6257 19.9998M35.7114 19.9998H23.6257",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70569 16.3743L33.2943 4.28857",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.3314V4.28857",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJusticeScaleOutline);
export default __webpack_public_path__ + "static/media/icon_justice_scale_outline.1f82b613cba33dc4ae578d7b7b6bdb49.svg";
export { ForwardRef as ReactComponent };